import ParentsVerification from './ParentsVerification'
import VerificationDeclined from './VerificationDeclined'

export default ParentsVerification
export { VerificationDeclined }
